import React from 'react';
import { useTranslation } from 'react-i18next';
import DashboardLayout from '../components/dashboard/DashboardLayout';
import MatchSuggestions from '../components/matching/MatchSuggestions';
import ConnectionsList from '../components/matching/ConnectionsList';

const ConnectionsPage = () => {
  const { t } = useTranslation();
  return (
    <DashboardLayout>
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900">{t('connections.title')}</h1>
        <p className="text-gray-500 mt-1">{t('connections.subtitle')}</p>
      </div>

      <div className="grid lg:grid-cols-2 gap-6">
        <MatchSuggestions />
        <ConnectionsList />
      </div>
    </DashboardLayout>
  );
};

export default ConnectionsPage;
